export const initialState = {
  fromdb: null,
  serviceOrders: null,
  paymentOrders: null,
  payments: null,
  deposits: null,
  isLoading: false,
  error: null,
};
